module.exports = __webpack_public_path__ + "img/u95.b267d870.jpg";